const API_URL = "https://api.stagb.in/dev/content/";
const EXPLAIN_URL = "https://api.stagb.in/dev/explain/";
const RAW_URL = "https://raw.stagb.in/StagBIN-Raw/";

export { API_URL, RAW_URL, EXPLAIN_URL };
